"use client";

import { ArrowRight, PhoneCall } from "lucide-react";
import { motion } from "framer-motion";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
export default function FinalQuoteCta() {
  return <section id="finalquotecta" className="py-16 md:py-24 lg:py-32 bg-primary">
      <div className="container mx-auto px-4 md:px-6">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        amount: 0.4
      }} transition={{
        duration: 0.6,
        ease: "easeOut"
      }} className="mx-auto max-w-4xl overflow-hidden rounded-2xl bg-card shadow-xl border border-border">
          <div className="flex flex-col items-center px-6 py-12 text-center sm:px-12 md:py-16 lg:px-20">
            <div className="mb-6 flex size-16 items-center justify-center rounded-lg bg-primary/10 text-primary">
              <PhoneCall className="size-8" />
            </div>
            
            <h2 className="font-default mb-4 text-3xl font-bold tracking-tight text-foreground sm:text-4xl md:text-5xl">
              Request a Bathroom Remodel Services Quote
            </h2>
            
            <p className="mb-8 max-w-2xl text-lg text-muted-foreground md:text-xl">
              Please submit the form to request a free bathroom remodel quote in Lakeland, FL.
            </p>
            
            <div className="flex w-full flex-col gap-4 sm:w-auto sm:flex-row sm:justify-center">
              <Link to="/ContactPage" className="w-full sm:w-auto">
                <Button size="lg" className="w-full text-base sm:w-auto">
                  Request a Free Quote
                  <ArrowRight className="ml-2 size-5" />
                </Button>
              </Link>
              
              <Link to="/contact/#quote" className="w-full sm:w-auto">
                <Button variant="outline" size="lg" className="w-full text-base sm:w-auto border-primary text-primary hover:bg-primary/5">
                  <PhoneCall className="mr-2 size-5" />
                  {"Get a free quote"}
                </Button>
              </Link>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}